import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Avatar, Badge, Box, chakra, ProgressCircle, Flex, Heading, Spinner, Stack, VStack, Wrap, Presence } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { ScoSignupRequest, ScoUser } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
export const SignupRequestPreviewUserMatches = props => {
  const $ = _c(22);
  const {
    getBreakpointValue,
    isMobile
  } = useBreakpointContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      query ($selectedSkillTitles: [String]) {
        scoUserSearchDraft(selectedSkillTitles: $selectedSkillTitles, matchedUsersLimit: 1000) {
          id
          relevantSkills
          matchedUsers {
            id
            displayName
            pictureUrl
            skills {
              id
              title
            }
          }
          matchedUsersCount
        }
      }
    `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = props.signupRequest?.skillTagTitles;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      ssr: false,
      variables: {
        selectedSkillTitles: t1
      }
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const draftQuery = useQuery(t0, t2);
  let t3;
  if ($[3] !== draftQuery.data?.scoUserSearchDraft?.matchedUsers || $[4] !== draftQuery.data?.scoUserSearchDraft?.matchedUsersCount || $[5] !== getBreakpointValue || $[6] !== isMobile) {
    const matchedUsers = draftQuery.data?.scoUserSearchDraft?.matchedUsers || [];
    let t4;
    if ($[8] !== getBreakpointValue) {
      t4 = getBreakpointValue([3, 3, 4]);
      $[8] = getBreakpointValue;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] !== getBreakpointValue) {
      t5 = getBreakpointValue([4, 4, 6, 6, 6]);
      $[10] = getBreakpointValue;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    const t6 = isMobile ? "sm" : "lg";
    const t7 = isMobile ? "none" : "inline";
    let t8;
    if ($[12] !== t7) {
      t8 = <chakra.span display={t7}>Good news!</chakra.span>;
      $[12] = t7;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    let t9;
    if ($[14] !== draftQuery.data?.scoUserSearchDraft?.matchedUsersCount) {
      t9 = draftQuery.data?.scoUserSearchDraft?.matchedUsersCount ? draftQuery.data?.scoUserSearchDraft?.matchedUsersCount?.toLocaleString() : <Spinner />;
      $[14] = draftQuery.data?.scoUserSearchDraft?.matchedUsersCount;
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    let t10;
    if ($[16] !== t9) {
      t10 = <Badge bgColor="purple.300" borderRadius="lg" color="black" fontSize="0.9em" fontWeight="inherit" marginX={2} padding="0.75" size="md">{t9}</Badge>;
      $[16] = t9;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    let t11;
    if ($[18] !== t10 || $[19] !== t6 || $[20] !== t8) {
      t11 = <Heading size={t6} textAlign="center">{t8}{" We have"}{t10}potential matches for you.</Heading>;
      $[18] = t10;
      $[19] = t6;
      $[20] = t8;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    t3 = <VStack align="center" background="colorPalette.container" borderRadius="xl" gap={t4} justify="center" padding={t5} width="full">{t11}<Wrap gap="0" justify="center" size="lg" spaceX="-1">{matchedUsers.slice(0, 14).map(_temp)}</Wrap>{!isMobile && <VStack align="center" gap={2} justify="center" width="full">{matchedUsers.slice(0, 3).map(_temp2)}</VStack>}</VStack>;
    $[3] = draftQuery.data?.scoUserSearchDraft?.matchedUsers;
    $[4] = draftQuery.data?.scoUserSearchDraft?.matchedUsersCount;
    $[5] = getBreakpointValue;
    $[6] = isMobile;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
const MatchCard = props => {
  const $ = _c(25);
  let t0;
  if ($[0] !== props.user.displayName) {
    t0 = <Avatar.Fallback borderRadius="md" name={props.user.displayName} />;
    $[0] = props.user.displayName;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.user.pictureUrl) {
    t1 = <Avatar.Image borderRadius="md" src={props.user.pictureUrl} />;
    $[2] = props.user.pictureUrl;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <Avatar.Root bgColor="colorPalette.fg" borderRadius="md" filter="blur(4px)" size="lg">{t0}{t1}</Avatar.Root>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props.user.displayName) {
    t3 = <Heading filter="blur(4px)" size="md">{props.user.displayName}</Heading>;
    $[7] = props.user.displayName;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== props.user.skills) {
    t4 = props.user.skills.slice(0, 3).map(_temp3);
    $[9] = props.user.skills;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <Wrap align="center" direction="row" gap={1} justify="start">{t4}</Wrap>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t5) {
    t6 = <VStack align="start" gap={2} justify="start" width="full">{t3}{t5}{" "}</VStack>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t2 || $[17] !== t6) {
    t7 = <Stack align="center" direction="row" gap={4} justify="center" padding={4} width="full">{t2}{t6}</Stack>;
    $[16] = t2;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ProgressCircle.Circle><ProgressCircle.Track stroke="colorPalette.bg" /><ProgressCircle.Range stroke="colorPalette.500" /></ProgressCircle.Circle>;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== props.matchScore) {
    t9 = <Flex align="center" alignSelf="stretch" bgColor="sidebarBackground" justify="center" padding={2}><ProgressCircle.Root value={props.matchScore}>{t8}</ProgressCircle.Root></Flex>;
    $[20] = props.matchScore;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t7 || $[23] !== t9) {
    t10 = <Stack align="center" background="PurpleSlate" borderRadius="lg" boxShadow="lg" direction="row" gap={0} justify="start" overflow="hidden" padding={0} width="full">{t7}{t9}</Stack>;
    $[22] = t7;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};
function _temp(user, i) {
  return <Presence key={i} animationDuration="moderate" present={true} style={{
    animationDelay: `${i / 10}s`
  }} animationName={{
    _open: "slide-from-bottom, fade-in",
    _closed: "slide-to-bottom, fade-out"
  }}><Avatar.Root border="1px solid white" size="sm"><Avatar.Fallback name={user.displayName} /><Avatar.Image src={user.pictureUrl} /></Avatar.Root></Presence>;
}
function _temp2(user_0, i_0) {
  return <Box key={i_0} width="full"><Presence animationDuration="moderate" present={true} style={{
      animationDelay: `${i_0 / 10}s`
    }} animationName={{
      _open: "slide-from-bottom, fade-in",
      _closed: "slide-to-bottom, fade-out"
    }}><MatchCard key={i_0} matchScore={100 - i_0 * 3} user={user_0} /></Presence></Box>;
}
function _temp3(skill, i) {
  return <Badge key={i} backgroundColor="blackAlpha.600" border="none" borderRadius="sm" boxShadow="none" color="colorPalette.border" fontSize="10px" fontWeight="600" letterSpacing="0.05em" lineHeight="1" overflow="hidden" padding={1} textAlign="center" textOverflow="ellipsis" textTransform="uppercase" variant="subtle" whiteSpace="nowrap">{skill.title}</Badge>;
}